import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'semantic-ui-react';
import ProLabel from 'components/common/ProLabel';
import './MenuCheckBox.css';

function MenuCheckBox(props) {
  const {
    linkId,
    initialValue,
    parameter,
    patchFunction,
    label,
    proLabel,
    disabled,
  } = props;

  const [currentValue, setCurrentValue] = useState(null);

  useEffect(() => {
    if (!currentValue) {
      setCurrentValue(initialValue);
    }
  }, []);

  const onCheckboxChange = (_e, { checked }) => {
    const form = new FormData();
    form.append(parameter, checked);
    patchFunction(linkId, form);
    setCurrentValue(!currentValue);
  };

  return (
    <div className="menu-checkbox__component">
      {(label || proLabel) &&
        <div className="labels-content">
          {label && <div className="label">{label}</div>}
          {proLabel && <ProLabel />}
        </div>
      }
      <Checkbox
        toggle
        checked={currentValue}
        onChange={onCheckboxChange}
        disabled={disabled}
      />
    </div>
  );
}

MenuCheckBox.propTypes = {
  linkId: PropTypes.number.isRequired,
  initialValue: PropTypes.bool,
  parameter: PropTypes.string,
  patchFunction: PropTypes.func.isRequired,
  label: PropTypes.string,
  proLabel: PropTypes.bool,
  disabled: PropTypes.bool,
}

MenuCheckBox.defaultProps = {
  label: null,
  proLabel: null,
  disabled: null,
};

export default MenuCheckBox;